import React, { useEffect, useRef, useState } from "react";
import Button from "../Button/Button";
import ArrowUpRight from "@assets/images/icons/arrow-right-dark-green.svg";
import { addSubscriber } from "@lib/apis/mailChimp";
import * as toast from "@lib/toast";
import "./NewsletterBar.css";

export const NEWSLETTER_ANCHOR_ID = "newsletter";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Footer-resident newsletter signup. The nav's "Newsletter" item scrolls
// here; when the user arrives from another page the hash survives the
// navigation, so we scroll ourselves once on mount.
const NewsletterBar = () => {
  const [email, setEmail] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.location.hash !== `#${NEWSLETTER_ANCHOR_ID}`) return;

    const frame = window.requestAnimationFrame(() => {
      document
        .getElementById(NEWSLETTER_ANCHOR_ID)
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      inputRef.current?.focus({ preventScroll: true });
    });

    return () => window.cancelAnimationFrame(frame);
  }, []);

  const handleSubmit = async () => {
    if (!EMAIL_REGEX.test(email.trim())) {
      toast.error("Invalid email address");
      return;
    }

    try {
      const response = await addSubscriber(email.trim());
      if (!response) {
        throw new Error("Network error");
      }
      toast.success("Subscribed successfully");
      setEmail("");
    } catch (error) {
      toast.error("An error occurred while subscribing");
    }
  };

  return (
    <section
      className="footer-newsletter"
      id={NEWSLETTER_ANCHOR_ID}
      aria-labelledby="footer-newsletter-heading"
    >
      <div className="footer-newsletter__copy">
        <h3 className="footer-newsletter__heading" id="footer-newsletter-heading">
          Sign up for our newsletter
        </h3>
        <p className="footer-newsletter__subtext">
          Legal AI that actually ships — product updates and practice notes, no spam.
        </p>
      </div>

      <form
        className="footer-newsletter__form"
        onSubmit={(event) => {
          event.preventDefault();
          handleSubmit();
        }}
        noValidate
      >
        <input
          ref={inputRef}
          type="email"
          name="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Your email"
          className="footer-newsletter__input"
          id="newsletter-email-input"
          aria-label="Email address for newsletter signup"
          autoComplete="email"
          maxLength={320}
        />
        <Button
          type="submit"
          className="button--circle-transparent"
          aria-label="Submit email for newsletter signup"
        >
          <img
            src={ArrowUpRight}
            className="footer-newsletter__arrow"
            alt=""
            width="24"
            height="24"
          />
        </Button>
      </form>
    </section>
  );
};

export default NewsletterBar;
